import type { ColumnDef } from '@tanstack/react-table';
import { SERIAL_COLUMN_ID } from './dataTable.constants';

const SERIAL_COLUMN_HEADER = 'SL';

export function createSerialColumn<TData>(): ColumnDef<TData, unknown> {
  return {
    id: SERIAL_COLUMN_ID,
    header: SERIAL_COLUMN_HEADER,
    cell: ({ row }) => row.index + 1,
  };
}
